import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
// mui components
import { Box, FormHelperText, Grid, TextField, Typography } from '@mui/material';
// styles
import { textfieldStyles } from './styles';
import { styles } from '../../styles';

type Props = {
  name: string;
  label: string;
  placeholder: string;
  className?: string;
  error?: string;
  optional?: boolean;
  withError?: boolean;
  disabled?: boolean;
};

const InputController: React.FC<Props> = ({
  name,
  className = '',
  label,
  placeholder,
  withError,
  optional = false,
  disabled = false,
}) => {
  const { control } = useFormContext();

  return (
    <Box>
      <Grid sx={styles.labelContainer}>
        <Typography sx={styles.label}>{label}</Typography>
        {optional ? <Typography sx={styles.optional}>optional</Typography> : null}
      </Grid>
      <Controller
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <>
            <TextField
              sx={textfieldStyles}
              value={value}
              onChange={onChange}
              className={className}
              fullWidth
              placeholder={placeholder}
              multiline
              maxRows={5}
              minRows={1}
              disabled={disabled}
            />

            {withError && error && error?.message != ' ' && (
              <FormHelperText sx={{ margin: '3px 0', color: 'red' }}>
                {error?.message || ' '}
              </FormHelperText>
            )}
          </>
        )}
        name={name}
        control={control}
      />
    </Box>
  );
};

export default InputController;
